import React from "react";
import { Link } from "react-router-dom";

const T = "#00c896";
const N = "#0f2040";

const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" stroke={N} strokeWidth="2"/>
    <path d="M20 20L16.5 16.5" stroke={N} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const BlogSidebar: React.FC = () => {
  const recentPosts = [
    { title: "How passive liveness beats active liveness in 2025", author: "Tim TrustEngine" },
    { title: "BI SNAP compliance checklist for payment providers", author: "Tim TrustEngine" },
    { title: "AML screening: PEP vs sanctions vs watchlist explained", author: "Tim TrustEngine" },
  ];

  const categories = [
    { name: "eKYC & Identity", count: 8 },
    { name: "AML & Compliance", count: 5 },
    { name: "Fraud Prevention", count: 6 },
    { name: "OJK Regulation", count: 4 },
    { name: "API & Developers", count: 7 },
    { name: "Case Studies", count: 3 },
  ];

  const tags = ["eKYC", "Liveness Detection", "OJK", "AML", "KYC API", "OCR", "Face Match", "Fraud"];

  return (
    <div className="col-lg-4 mt-50">
      <div className="sidebar">

        {/* Search */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Search</h3>
          <div className="form-group">
            <input className="form-control" type="search" placeholder="Search articles..." />
            <button type="submit" className="search_icon"><span><SearchIcon /></span></button>
          </div>
        </div>

        {/* Newsletter CTA */}
        <div className="sidebar_widget">
          <div style={{
            background: `linear-gradient(135deg, ${N} 0%, #1a3460 100%)`,
            borderRadius: 14, padding: "28px 24px", textAlign: "center",
          }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>🔒</div>
            <h4 style={{ color: "white", fontWeight: 800, fontSize: 16, marginBottom: 8 }}>Identity & Compliance Newsletter</h4>
            <p style={{ color: "rgba(255,255,255,0.55)", fontSize: 13, marginBottom: 20, lineHeight: 1.6 }}>
              Monthly digest: OJK updates, eKYC best practices, and fraud trends.
            </p>
            <input
              type="email"
              placeholder="your@email.com"
              style={{
                width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.15)",
                background: "rgba(255,255,255,0.08)", color: "white", fontSize: 13,
                outline: "none", marginBottom: 12, boxSizing: "border-box",
              }}
            />
            <button style={{
              width: "100%", padding: "10px 0", borderRadius: 8, background: T,
              border: "none", color: N, fontWeight: 800, fontSize: 13, cursor: "pointer",
            }}>
              Subscribe
            </button>
          </div>
        </div>

        {/* Recent Posts */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Recent Posts</h3>
          <ul className="recent_post_block list-unstyled">
            {recentPosts.map((post, i) => (
              <li key={i} className="recent_post_item xb-border">
                <h3 className="post-title border-effect-2">
                  <Link to="/blog-details">{post.title}</Link>
                </h3>
                <span style={{ fontSize: 12, color: "rgba(15,32,64,0.45)" }}>
                  ✍ {post.author}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* Categories */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Categories</h3>
          <ul className="category_list_block list-unstyled">
            {categories.map((cat, i) => (
              <li key={i}>
                <Link to="/blog-details">
                  <span><i className="far fa-arrow-right"></i> {cat.name}</span>
                  <span>({String(cat.count).padStart(2, "0")})</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Tags */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Tags</h3>
          <ul className="tags_block list-unstyled">
            {tags.map((tag, i) => (
              <li key={i}>
                <Link className="xb-border" to="#!">{tag}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* API CTA */}
        <div className="sidebar_widget">
          <div style={{
            borderRadius: 14, padding: "24px", background: "rgba(0,200,150,0.06)",
            border: "1.5px solid rgba(0,200,150,0.2)",
          }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: T, marginBottom: 8 }}>Ready to integrate?</div>
            <p style={{ fontSize: 13, color: "rgba(15,32,64,0.6)", lineHeight: 1.65, marginBottom: 16 }}>
              Get your API key and verify your first identity in under 1 hour.
            </p>
            <Link to="/contact" style={{
              display: "block", textAlign: "center", padding: "10px 0",
              background: N, color: "white", borderRadius: 8, fontSize: 13,
              fontWeight: 700, textDecoration: "none",
            }}>
              Get API Key →
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default BlogSidebar;
